"use client";

import { TextLink as TertiaryLinkImport } from "./TextAction/TextLink";

export { TertiaryButton as TextButtonLink } from "./TextAction/TertiaryButton";
export { TextALink } from "./TextAction/TextALink";
export { TextLink } from "./TextAction/TextLink";
export { LinkStyles } from "./TextAction/common";
export default TertiaryLinkImport;
